/* MD Sports — Compre Junto (Frequently Bought Together) */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';
    function build(precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var number = (Math.abs(cents) / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }
    var value;
    switch ((fmt.match(placeholderRegex) || [])[1]) {
      case 'amount': value = build(2, ',', '.'); break;
      case 'amount_no_decimals': value = build(0, ',', ''); break;
      case 'amount_with_comma_separator': value = build(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = build(0, '.', ''); break;
      case 'amount_with_space_separator': value = build(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = build(0, ' ', ''); break;
      default: value = build(2, ',', '.');
    }
    return fmt.replace(placeholderRegex, value);
  }

  function getSectionInnerHTML(html, selector) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var el = tmp.querySelector(selector);
    return el ? el.innerHTML : html;
  }

  // Mesmas seções que o tema re-renderiza ao adicionar ao carrinho
  var CART_SECTIONS = [
    { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
    { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];

  function initSection(root) {
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var rows = Array.prototype.slice.call(root.querySelectorAll('.md-bt__row'));
    var totalEl = root.querySelector('.md-bt__total-value');
    var countEl = root.querySelector('.md-bt__count-value');
    var form = root.querySelector('.md-bt__form');
    var addBtn = root.querySelector('.md-bt__add');

    function rowState(row) {
      var check = row.querySelector('.md-bt__check');
      var select = row.querySelector('.md-bt__variant');
      var id = row.dataset.variantId;
      var price = parseInt(row.dataset.price, 10) || 0;
      if (select) {
        var opt = select.options[select.selectedIndex];
        if (opt) { id = opt.value; price = parseInt(opt.dataset.price, 10) || 0; }
      }
      return { checked: check && check.checked, id: id, price: price };
    }

    function recalc() {
      var total = 0, count = 0;
      rows.forEach(function (row) {
        var s = rowState(row);
        row.classList.toggle('is-off', !s.checked);
        var pv = root.querySelector('.md-bt__preview[data-pid="' + row.dataset.pid + '"]');
        if (pv) pv.classList.toggle('is-off', !s.checked);
        if (s.checked) { total += s.price; count += 1; }
      });
      if (totalEl) totalEl.textContent = formatMoney(total, moneyFormat);
      if (countEl) countEl.textContent = count;
    }

    rows.forEach(function (row) {
      var check = row.querySelector('.md-bt__check');
      var select = row.querySelector('.md-bt__variant');
      if (check) check.addEventListener('change', recalc);
      if (select) select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        if (opt) { row.dataset.variantId = opt.value; row.dataset.price = opt.dataset.price; }
        var priceEl = row.querySelector('.md-bt__price');
        if (priceEl && opt) priceEl.textContent = formatMoney(parseInt(opt.dataset.price, 10) || 0, moneyFormat);
        recalc();
      });
    });

    function cartUrl() {
      return (window.theme && theme.routes && theme.routes.cart_url) ? theme.routes.cart_url : '/cart';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = rows.map(rowState).filter(function (s) { return s.checked && s.id; })
        .map(function (s) { return { id: parseInt(s.id, 10), quantity: 1 }; });
      if (!items.length) return;

      var addUrl = (window.theme && theme.routes && theme.routes.cart_add_url) ? theme.routes.cart_add_url : '/cart/add.js';
      if (addBtn) { addBtn.classList.add('loading'); addBtn.setAttribute('aria-busy', 'true'); }

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: items,
          sections: CART_SECTIONS.map(function (s) { return s.section; }),
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status) { window.location = cartUrl(); return; } // erro (422 etc.)
          // Re-renderiza drawer + contador exatamente como o tema faz
          if (res.sections) {
            CART_SECTIONS.forEach(function (s) {
              var container = document.getElementById(s.id);
              if (!container || !res.sections[s.section]) return;
              var target = container.querySelector(s.selector) || container;
              target.innerHTML = getSectionInnerHTML(res.sections[s.section], s.selector);
            });
          }
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (typeof dispatchCustomEvent === 'function') {
            dispatchCustomEvent('cart:item-added', { product: res.items ? res.items[0] : res });
          }
          var drawer = document.getElementById('Cart-Drawer');
          if (window.OverlayManager && drawer) {
            OverlayManager.open(drawer);
            if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('cart-drawer:open');
          } else {
            window.location = cartUrl(); // fallback garantido
          }
        })
        .catch(function () { window.location = cartUrl(); })
        .finally(function () { if (addBtn) { addBtn.classList.remove('loading'); addBtn.removeAttribute('aria-busy'); } });
    });

    recalc();
  }

  function boot() {
    document.querySelectorAll('.md-bought-together').forEach(initSection);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.md-bought-together');
    if (el) initSection(el);
  });
})();
